// English for Settings › « Fournisseurs IA » and « Comparer les modèles » (2026-10-23). French string = key.
const m: Record<string, string> = {
  // Settings cluster
  'Fournisseurs IA': 'AI providers',
  'Fournisseurs': 'Providers',
  'Tâches': 'Tasks',
  'Quel modèle pour chaque tâche IA': 'Which model for each AI task',
  'Haiku / Sonnet et leurs règles': 'Haiku / Sonnet and their rules',
  'Chaque tâche sur chaque modèle Claude': 'Each task on each Claude model',
  'Réglages IA indisponibles. Réessayez.': 'AI settings unavailable. Try again.',

  // Providers + keys
  'Clés, interrupteurs et budgets. Une clé n’est jamais affichée : seulement ses 4 derniers caractères.': 'Keys, switches and budgets. A key is never shown: only its last 4 characters.',
  'Comparer les modèles': 'Compare models',
  'Activer {p}': 'Turn on {p}',
  'Garde les messages vocaux (Claude n’entend pas l’audio)': 'Keeps the voice messages (Claude cannot hear audio)',
  'Clé API': 'API key',
  'enregistrée ici': 'saved here',
  'secret du worker': 'worker secret',
  'aucune': 'none',
  'le {d}': 'on {d}',
  'Changer la clé': 'Change the key',
  'Nouvelle clé': 'New key',
  'Collez la nouvelle clé': 'Paste the new key',
  'Retirer la clé enregistrée': 'Remove the saved key',
  'Retirer la clé enregistrée ici ?': 'Remove the key saved here?',
  'Le secret AI_KEYS_ENC_KEY n’est pas créé : impossible d’enregistrer une clé': 'The AI_KEYS_ENC_KEY secret does not exist: a key cannot be saved',
  'Échec du test': 'Test failed',
  'Dépensé ce mois': 'Spent this month',
  'sur {b} ({p} %)': 'of {b} ({p} %)',
  'pas de budget': 'no budget',
  'Budget mensuel (USD)': 'Monthly budget (USD)',
  'ID de l’espace de travail': 'Workspace ID',
  'Seulement si votre clé est liée à toute l’organisation. Console Claude › Settings › Workspaces › colonne « ID ». Ensuite, « Tester ».': 'Only if your key belongs to the whole organisation. Claude Console › Settings › Workspaces › « ID » column. Then « Tester ».',
  'Enregistré': 'Saved',
  'Réinitialiser': 'Reset',

  // Anthropic extras
  'Anthropic — clé Admin': 'Anthropic — Admin key',
  'Clé Admin (facultative)': 'Admin key (optional)',
  'Sert seulement au contrôle quotidien des coûts (ce que nous comptons vs ce qu’Anthropic facture).': 'Only used for the daily cost check (what we count vs what Anthropic bills).',
  'Anthropic — crédit gratuit': 'Anthropic — free credit',
  'Montant (USD)': 'Amount (USD)',
  'Début': 'Start',
  'Fin / renouvellement': 'End / renewal',
  'Utilisé': 'Used',
  'Reste': 'Left',
  '{p} % utilisé': '{p} % used',
  '{n} jours restants': '{n} days left',
  'Au rythme de {r}/jour (7 derniers jours), le crédit sera épuisé le {d}': 'At {r}/day (last 7 days), the credit runs out on {d}',
  'Au rythme de {r}/jour (7 derniers jours), le crédit ne sera pas épuisé avant la fin': 'At {r}/day (last 7 days), the credit will not run out before the end',
  'avant la fin ({d})': 'before the end ({d})',
  'Anthropic — montant console et contrôle quotidien': 'Anthropic — console amount and daily check',
  'Le montant affiché dans la console Anthropic. Utilisé pour le contrôle quotidien quand il n’y a pas de clé Admin.': 'The amount shown in the Anthropic console. Used for the daily check when there is no Admin key.',
  'Montant console (USD)': 'Console amount (USD)',
  'Contrôle quotidien : pas encore de journée vérifiée.': 'Daily check: no day checked yet.',
  'Contrôle du {d} ({s}) : nous {o} · Anthropic {a} · écart {g}': 'Check of {d} ({s}): us {o} · Anthropic {a} · gap {g}',
  'clé Admin': 'Admin key',
  'console': 'console',
  'depuis le {d}': 'since {d}',
  'Tarifs (USD par million de tokens)': 'Prices (USD per million tokens)',
  'Entrée (tokens)': 'Input',
  'Écriture cache 5 min': 'Cache write 5 min',
  'Écriture cache 1 h': 'Cache write 1 h',
  'Lecture cache': 'Cache read',
  'Sortie (tokens)': 'Output',
  'Prompt long : au-delà de': 'Long prompt: above',
  'Seuil en tokens': 'Threshold in tokens',
  'tokens': 'tokens',

  // Tasks
  'Quel fournisseur et quel modèle pour chaque tâche IA, et le secours si le premier échoue. Par défaut : OpenRouter, le modèle actuel, aucun changement enregistré.': 'Which provider and model for each AI task, and the fallback if the first fails. Default: OpenRouter, the current model, nothing saved.',
  'Tâche': 'Task',
  'Principal': 'Primary',
  'Secours': 'Fallback',
  'Image': 'Image',
  'Image (côté long)': 'Image (long side)',
  'Appels / 30 j': 'Calls / 30 d',
  'Coût / mois': 'Cost / month',
  'Audio : OpenRouter seulement': 'Audio: OpenRouter only',
  'Aucun': 'None',
  'OpenRouter — actuel : {m}': 'OpenRouter — current: {m}',
  'OpenRouter — actuel ({m})': 'OpenRouter — current ({m})',
  'OpenRouter — actuel': 'OpenRouter — current',
  'Principal — {task}': 'Primary — {task}',
  'Secours — {task}': 'Fallback — {task}',
  'Côté long de l’image — {task}': 'Image long side — {task}',

  // WhatsApp easy / complex
  'Réponses WhatsApp : facile / complexe': 'WhatsApp replies: easy / complex',
  'Les messages simples vont au modèle « facile », tout le reste au modèle « complexe ».': 'Simple messages go to the « easy » model, everything else to the « complex » one.',
  'Routeur facile / complexe — {p}': 'Easy / complex router — {p}',
  'OFF par défaut': 'OFF by default',
  'Haiku = facile, Sonnet = complexe ; dans le doute → Sonnet ; une conversation passée en Sonnet y reste {n} minutes.': 'Haiku = easy, Sonnet = complex; when in doubt → Sonnet; a chat that went to Sonnet stays there {n} minutes.',
  'Modèle « facile »': '« Easy » model',
  'Modèle « complexe »': '« Complex » model',
  'Mots « argent » (toujours complexe)': '« Money » words (always complex)',
  'Mots « plainte » (toujours complexe)': '« Complaint » words (always complex)',
  'Mots « changement d’album » (toujours complexe)': '« Album change » words (always complex)',
  'Mots « faciles » (salutations, merci…)': '« Easy » words (greetings, thanks…)',
  'Marqueurs de darija': 'Darija markers',
  'Séparez les mots par des virgules.': 'Separate the words with commas.',
  'Facile : max. caractères': 'Easy: max characters',
  'Facile : max. questions': 'Easy: max questions',
  'Reste en complexe (minutes)': 'Stays complex (minutes)',

  // Estimate
  'Estimation des coûts': 'Cost estimate',
  'Ce que chaque tâche coûterait par mois sur chaque modèle Claude, au trafic des 30 derniers jours.': 'What each task would cost per month on each Claude model, at the last 30 days’ traffic.',
  'Appels / mois': 'Calls / month',
  'Actuel / mois': 'Current / month',
  'hypothèse de cache': 'cache assumption',
  '{n} tâches sans appel sur 30 jours (non affichées).': '{n} tasks without a call in 30 days (not shown).',
  'Réponses WhatsApp : hypothèse de {p} % de l’entrée lue depuis le cache (prompt système + Brain). C’est une hypothèse, pas une mesure.': 'WhatsApp replies: assumes {p} % of the input is read from cache (system prompt + Brain). An assumption, not a measurement.',
  'Réponses WhatsApp sur Claude': 'WhatsApp replies on Claude',
  'Aujourd’hui (actuel)': 'Today (current)',
  'Tout Sonnet': 'All Sonnet',
  'Mixte Haiku / Sonnet': 'Mixed Haiku / Sonnet',
  'part facile inconnue': 'easy share unknown',
  '{p} % de messages faciles': '{p} % easy messages',
  '{n} réponses sur 30 jours': '{n} replies in 30 days',
  '{i} tokens en entrée, {o} en sortie en moyenne': '{i} input tokens, {o} output on average',
  'cache supposé : {p} %': 'assumed cache: {p} %',
  'Total sur Claude vs budget': 'Claude total vs budget',
  'Projection': 'Projection',
  'avec 30 % de marge': 'with a 30 % buffer',
  'pas de budget Claude': 'no Claude budget',
  'budget Claude {b}': 'Claude budget {b}',

  // Compare page
  'Les mêmes cas réels sur l’ancien et le nouveau modèle': 'The same real cases on the old and the new model',
  'Nouvelle comparaison': 'New comparison',
  'Ancien': 'Old',
  'Nouveau': 'New',
  'Cas (max 20)': 'Cases (max 20)',
  'Plafond ($)': 'Cap ($)',
  '{x} — actuel': '{x} — current',
  'Claude mixte (Haiku/Sonnet)': 'Claude mixed (Haiku/Sonnet)',
  'Cas choisis parmi': 'Cases picked among',
  'Choisissez deux modèles différents.': 'Pick two different models.',
  'Estimation…': 'Estimating…',
  'Estimation indisponible': 'Estimate unavailable',
  'Estimation': 'Estimate',
  'pour {n} cas': 'for {n} cases',
  'par cas : ancien {o}, nouveau {w}': 'per case: old {o}, new {w}',
  'plafond {c}': 'cap {c}',
  'dépasse le plafond : la comparaison s’arrêtera avant la fin': 'over the cap: the comparison will stop before the end',
  'Lancer': 'Start',
  'Liste des tâches indisponible. Réessayez.': 'Task list unavailable. Try again.',
  'Aucune tâche comparable pour l’instant.': 'No comparable task yet.',
  'Comparaisons': 'Comparisons',
  'Aucune comparaison pour l’instant.': 'No comparison yet.',
  'Choisissez une comparaison, ou lancez-en une.': 'Pick a comparison, or start one.',
  'Comparaison introuvable.': 'Comparison not found.',
  'en file': 'queued',
  'terminé': 'done',
  'arrêté': 'stopped',
  'échoué': 'failed',
  'Arrêter': 'Stop',
  'Cas traités': 'Cases done',
  'Dépensé': 'Spent',
  'estimé {x}': 'estimated {x}',
  'Coût ancien': 'Old cost',
  'Coût nouveau': 'New cost',
  'Temps moyen': 'Average time',
  'ancien / nouveau': 'old / new',
  'Verdicts': 'Verdicts',
  'Verdict': 'Verdict',
  'ancien · nouveau · pareil': 'old · new · same',
  '{n} cas à vérifier': '{n} cases to check',
  'À vérifier': 'To check',
  'ancien meilleur': 'old better',
  'nouveau meilleur': 'new better',
  'pareil': 'same',
  'Les cas arrivent…': 'Cases are coming…',
  'Aucun cas.': 'No case.',
  '{n} visage': '{n} face',
  '{n} visages': '{n} faces',
  'Haiku': 'Haiku',
  'Sonnet': 'Sonnet',
  'escalade': 'escalated',
  // case tags
  'arabe': 'Arabic',
  'argent': 'money',
  'client fâché': 'angry customer',
  'photo floue/petite': 'blurry/small photo',
  'photo': 'photo',
};
export default m;
